<template>
    <div v-if="isLoaded">
        <div class="text-12 text-center py-2">
            {{lbl.earnpoint.show_our_staff}}
        </div>
        <div class="flex justify-center items-center">
            <VueQrcode :value="profileQR.Key" :options="qrOption"></VueQrcode>
        </div>
        <div class="text-18 text-a-brown-502314 text-center tracking-widest pb-4">{{profileQR.Key}}</div>
        <div class="flex justify-center items-center">
            <div class="my-auto mr-1 text-14 text-a-brown-502314">{{lbl.earnpoint.qr_code_valid}} {{displayTime}}{{lbl.earnpoint.min}}</div>
            <img class="my-auto cursor-pointer" @click="clickReload()" src="@/assets/earnpoint/ic-refresh.svg" />
        </div>

    </div>
</template>

<script>
//Helper
import DatetimeHelper from '@/helper/DatetimeHelper.js';
import TimerHelper from '@/helper/TimerHelper.js';
//lib
import VueQrcode from '@chenfengyuan/vue-qrcode';
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "EarnPointQR",
    mixins: [AuthStatusMixin, ModalMixin, LocaleMixin],
    components: {
        VueQrcode,
    },
    data: function () {
        return {
            profileQR: null,
            isLoaded: false,

            qrOption: {
                width: 200,
                margin: 2,
            },

            displayTime: '',
            timer: new TimerHelper(),
        };
    },
    beforeUnmount: function() {
        this.stopTimer();
    },
    methods: {
        onAccountInit: function () {
            this.getQR()
        },
        getQR: async function() {
            await this.apiGetQR();
        },
        clickReload: function() {
            // this.$router.go()
            this.stopTimer();
            this.getQR();
        },
        apiGetQR:  function() {
            return new Promise((resolve) => {
                BzbsProfile.getQR().subscribe({
                    next: (data) => {
                        console.log(data);
                        this.profileQR = data;
                        this.isLoaded = true;
                        this.startTimer(this.profileQR.ExpireIn);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        getTimeExpire: function() {
            let dt = new Date();
            return DatetimeHelper.getDatetimeAddSeconds(dt, this.profileQR.ExpireIn);
        },

        startTimer: function (expireIn) {
            this.timer.initialTimer(expireIn,".");
            this.timer.runTimer((display) => {
                this.displayTime = display;
            }, () => {
                // expire
                this.stopTimer();
                this.getQR();
            });
        },

        stopTimer: function () {
            this.timer.stopTimer();
            this.timer.resetTimer();
        },
    }
}
</script>
<style>
</style>
